<div class="404-wrapper" [ngClass]="{ 'hidden': !doc.isActive, 'active-document': doc.isActive }" #docWrapper>
    <div class="wrapper doc-content-wrapper">
        <span class="header-text">{{ 'Error.wereSorry' | translate }}</span>
        <span class="body-text">{{ 'Error.docNotFound' | translate }}</span>
    </div>
</div>